import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'htmlString',
    standalone: false
})
export class DecodeHtmlString implements PipeTransform {
  transform(value: string) {
    if (!value) {
      return '';
    }

    let text = value
      .replace(/<\/?(p|div|br|li|ul|ol|h[1-6]|tr|td|th)(?:\s+[^>]*?)?>/gi, ' ')  // Optimized block elements
      .replace(/<[^>]*?>/g, ' ');

    const tempElement = document.createElement('div');
    tempElement.innerHTML = text;
    text = tempElement.textContent || tempElement.innerText || '';

    text = text
      .replace(/&nbsp;/g, ' ')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'");

    text = text.replace(/\s+/g, ' ');

    text = text.trim();

    return text;
  }
}
